import { httpV1 as http } from '../api';

export async function getToken(params) {
  const { data } = await http.post('/users/login', params);
  return data;
}
